export default __webpack_public_path__ + "static/media/phone-colored.e2cb23b7.svg";